import React from 'react';
import InteractiveScheduleManager from '@/components/schedule/InteractiveScheduleManager';

const SchedulePage: React.FC = () => {
  return (
    <div>
      <InteractiveScheduleManager />
    </div>
  );
};

export default SchedulePage;
